module.exports = __webpack_public_path__ + "assets/074b57143f31bc36b1ec8f66919b20ae.png";